import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetProductionJobEventAttachmentsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ProductionJobDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ProductionJobDocumentSortInput> | Types.ProductionJobDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetProductionJobEventAttachmentsQuery = { __typename?: 'Query', productionJobs?: { __typename?: 'ProductionJobsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionJobDocument', id: string, productionJobId: string, productionLotId: string, jobNumber: number, materialEventAttachments: Array<{ __typename?: 'ProductionJobEventAttachmentDocument', eventId: string, source: Types.ProductionEventAttachmentSource }>, spaceEventAttachments: Array<{ __typename?: 'ProductionJobEventAttachmentDocument', eventId: string, source: Types.ProductionEventAttachmentSource }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type ProductionJobEventAttachmentsSummaryFragment = { __typename?: 'ProductionJobDocument', id: string, productionJobId: string, productionLotId: string, jobNumber: number, materialEventAttachments: Array<{ __typename?: 'ProductionJobEventAttachmentDocument', eventId: string, source: Types.ProductionEventAttachmentSource }>, spaceEventAttachments: Array<{ __typename?: 'ProductionJobEventAttachmentDocument', eventId: string, source: Types.ProductionEventAttachmentSource }> };

export type ProductionJobEventAttachmentFragment = { __typename?: 'ProductionJobEventAttachmentDocument', eventId: string, source: Types.ProductionEventAttachmentSource };

export type ProductionLotEventAttachmentStateFragment = { __typename?: 'ProductionLotStateData', productionLotId: string, status: Types.ProductionLotStatus };

export const ProductionJobEventAttachmentFragmentDoc = new TypedDocumentString(`
    fragment ProductionJobEventAttachment on ProductionJobEventAttachmentDocument {
  eventId
  source
}
    `, {"fragmentName":"ProductionJobEventAttachment"});
export const ProductionJobEventAttachmentsSummaryFragmentDoc = new TypedDocumentString(`
    fragment ProductionJobEventAttachmentsSummary on ProductionJobDocument {
  id
  productionJobId
  productionLotId
  jobNumber
  materialEventAttachments {
    ...ProductionJobEventAttachment
  }
  spaceEventAttachments {
    ...ProductionJobEventAttachment
  }
}
    fragment ProductionJobEventAttachment on ProductionJobEventAttachmentDocument {
  eventId
  source
}`, {"fragmentName":"ProductionJobEventAttachmentsSummary"});
export const ProductionLotEventAttachmentStateFragmentDoc = new TypedDocumentString(`
    fragment ProductionLotEventAttachmentState on ProductionLotStateData {
  productionLotId
  status
}
    `, {"fragmentName":"ProductionLotEventAttachmentState"});
export const GetProductionJobEventAttachmentsDocument = new TypedDocumentString(`
    query GetProductionJobEventAttachments($where: ProductionJobDocumentFilterInput, $order: [ProductionJobDocumentSortInput!], $first: Int, $after: String) {
  productionJobs(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      ...ProductionJobEventAttachmentsSummary
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment ProductionJobEventAttachmentsSummary on ProductionJobDocument {
  id
  productionJobId
  productionLotId
  jobNumber
  materialEventAttachments {
    ...ProductionJobEventAttachment
  }
  spaceEventAttachments {
    ...ProductionJobEventAttachment
  }
}
fragment ProductionJobEventAttachment on ProductionJobEventAttachmentDocument {
  eventId
  source
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetProductionJobEventAttachments: build.query<GetProductionJobEventAttachmentsQuery, GetProductionJobEventAttachmentsQueryVariables | void>({
      query: (variables) => ({ document: GetProductionJobEventAttachmentsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetProductionJobEventAttachmentsQuery, useLazyGetProductionJobEventAttachmentsQuery } = injectedRtkApi;
